<template>
  <div class="animated fadeIn">
    <div class="card" >
        <DxVectorMap 
            v-bind:dxDataSourceData="geodata" 
            :bounds="boundsConfig">
            <dx-tooltip 
                :enabled="true"
                :customizeTooltip="customizeTooltip">
                <dx-border :visible="false" />
                <dx-font color="#000000"/>
            </dx-tooltip>
            <dx-layer 
                selectionMode="none"
                :dataSource="layerDataSource"
                :customize="layerCustomize" />
        </DxVectorMap>
    </div>
  </div>
</template>

<script>
  import DxVectorMap, { DxTooltip, DxBorder, DxFont, DxLayer } from 'devextreme-vue/vector-map';
  import dxMapWorld from 'devextreme/dist/js/vectormap-data/world';

  export default {
    name: 'DashboardPanelGeoMap',

    props:[
      'geodata'
    ],

    components:{
      DxVectorMap,
      DxTooltip,
      DxBorder,
      DxFont,
      DxLayer
    },

    data() {
      return {

        boundsConfig: [-10, 75, 45, 10],
        layerDataSource: dxMapWorld.world,
      }
    },

    mounted() {
    },

    methods:{
        customizeTooltip(arg) {
            var name = arg.attribute("name"),
                country = this.geodata[name];

            if (country) {
                return { text: name + ": " + country.score + "%", color: country.color };
            } else {
                return { text: name };
            }
        },

        layerCustomize(elements) {
            let data = this.geodata;

            elements.forEach(element => {
                var country = data[element.attribute("name")];

                if (country) {
                    element.applySettings({
                        color: country.color,
                        hoveredColor: "#d5001c",
                        hoveredBorderColor: "#FFFFFF"
                    });
                }
            });
        }
    },

    computed: {
    }
  }
</script>
